import React, { useState } from 'react';
import {
  Typography,
  Box,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Button,
  Collapse
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Link } from 'react-router-dom';

export const seoMeta = {
  title: 'Калъфки за възглавници за бебе и дете – 100% памук | GoToBed',
  description:
    'Калъфки за бебешки и детски възглавници от 100% памук. Ранфорс и памучен сатен, размери 30/40, 35/53, 40/60, 50/70. Поръчайте от GoToBed.'
};

const seoLinkStyle = {
  color: '#F57819',
  textDecoration: 'underline',
  fontWeight: 600,
  '&:hover': { color: '#A34D08' }
};

export function SeoHeader() {
  const [introExpanded, setIntroExpanded] = useState(false);

  return (
    <Box sx={{ mb: 3 }}>
      <Typography
        component="h1"
        sx={{
          position: 'absolute',
          width: '1px',
          height: '1px',
          padding: 0,
          margin: '-1px',
          overflow: 'hidden',
          clip: 'rect(0, 0, 0, 0)',
          whiteSpace: 'nowrap',
          borderWidth: 0
        }}>
        Калъфки за възглавници за бебе и дете – 100% памук
      </Typography>
      <Typography variant="h6" component="p" fontWeight={600} sx={{ mb: 2 }}>
        Калъфки за възглавници за бебе и дете – 100% памук и голямо разнообразие от размери
      </Typography>
      <Box
        sx={{
          ...(!introExpanded && {
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden'
          })
        }}>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          В тази категория ще откриете калъфки за бебешки и детски възглавници от 100% памук в
          едноцветни и шарени (с принт) десени. Моделите се изработват по поръчка и се предлагат в
          голямо разнообразие от размери, сред които 30/40, 35/53, 40/60 и 50/70, за да откриете
          лесно подходящата калъфка за бебе или дете. Всички модели са изработени от
          висококачествени 100% памучни материи, подходящи за чувствителната детска кожа.
        </Typography>
      </Box>
      <Button
        onClick={() => setIntroExpanded(!introExpanded)}
        size="small"
        sx={{
          color: '#F57819',
          textTransform: 'none',
          fontWeight: 600,
          p: 0,
          minWidth: 0,
          '&:hover': { backgroundColor: 'transparent', textDecoration: 'underline' }
        }}>
        {introExpanded ? 'Скрий' : 'Прочетете повече'}
      </Button>
    </Box>
  );
}

export default function SeoBody() {
  return <SeoBodyDetskiKalufki />;
}

function SeoBodyDetskiKalufki() {
  const [expanded, setExpanded] = useState(false);

  return (
    <Box sx={{ mt: 6 }}>
      {/* H2: Калъфки за възглавници за бебе и дете – 100% памук */}
      <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
        Калъфки за възглавници за бебе и дете – 100% памук
      </Typography>
      <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
        В тази категория ще откриете калъфки за възглавници за бебета и деца, изработени от
        висококачествени 100% памучни платове. Калъфката за възглавница е важна част от детското
        спално бельо, защото е в директен контакт с кожата на детето и допринася за комфортен,
        спокоен и хигиеничен сън.
      </Typography>
      <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
        В GoToBed предлагаме бебешки и детски калъфки за възглавници в голямо разнообразие от
        размери, което позволява лесно да намерите точния размер както за стандартни, така и за
        по-нестандартни възглавници. При нас можете да откриете калъфка за бебешка възглавница
        30/40, калъфка за детска възглавница 40/60, както и размери 35/53, 40/50 и 50/70, изработени
        от качествени 100% памучни материи.
      </Typography>
      <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
        Всички калъфки се изработват внимателно в България от висококачествени памучни платове –
        ранфорс и памучен сатен, сертифицирани по OEKO-TEX Standard 100. Този сертификат гарантира,
        че текстилът е безопасен за бебета и деца и не съдържа вредни вещества, което е особено
        важно за чувствителната детска кожа.
      </Typography>
      <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
        За да създадете удобен комплект детско спално бельо, можете да комбинирате калъфките с:
      </Typography>
      <Box sx={{ mb: 4, pl: 2 }}>
        <Typography
          variant="body1"
          component={Link}
          to="/kategorii/detsko-spalno-belio/detski-plikove/2/10"
          sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
          детски пликове за завивки
        </Typography>
        <Typography
          variant="body1"
          component={Link}
          to="/kategorii/detsko-spalno-belio/detski-charshafi/2/7"
          sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
          детски чаршафи
        </Typography>
        <Typography
          variant="body1"
          component={Link}
          to="/kategorii/detsko-spalno-belio/detski-charshafi-s-lastik/2/9"
          sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
          детски чаршафи с ластик
        </Typography>
      </Box>

      <Collapse in={expanded} collapsedSize={0}>
        {/* H2: Размери калъфки за детски и бебешки възглавници */}
        <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
          Размери калъфки за детски и бебешки възглавници
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Едно от основните предимства на нашите детски калъфки за възглавници е богатото
          разнообразие от размери. Това позволява лесно да намерите подходяща калъфка както за
          бебешки възглавници, така и за по-големи възглавници за деца.
        </Typography>
        <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
          Предлагаме калъфки за възглавници със следните размери:
        </Typography>
        <Box sx={{ mb: 2, pl: 2 }}>
          {[
            '28/35',
            '30/40',
            '33/43',
            '33/66',
            '35/53',
            '37/47',
            '40/50',
            '40/60',
            '43/63',
            '48/68',
            '50/70',
            '60/60',
            '70/70'
          ].map((item) => (
            <Typography key={item} variant="body1" sx={{ color: 'text.secondary' }}>
              {item}
            </Typography>
          ))}
        </Box>
        <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
          Сред най-търсените размери са:
        </Typography>
        <Box component="ul" sx={{ mb: 2, pl: 4, color: 'text.secondary' }}>
          <li>калъфка за бебешка възглавница 30/40 (30х40) см</li>
          <li>калъфка за детска възглавница 40/60 (40х60) см</li>
          <li>калъфка за възглавница 35/53 (35х53) см</li>
          <li>калъфка за възглавница 40/50 (40х50) см</li>
          <li>калъфка за възглавница 50/70 (50х70) см</li>
        </Box>
        <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary' }}>
          Това прави нашите калъфки подходящи както за бебешки възглавници, така и за по-големи
          детски възглавници.
        </Typography>

        {/* H2: Памучни калъфки – комфорт и безопасност за детето */}
        <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
          Памучни калъфки – комфорт и безопасност за детето
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Всички калъфки се изработват от 100% памучни материи, които са дишащи, меки и приятни на
          допир. Памукът е естествен материал, който позволява на кожата да диша и намалява риска от
          раздразнения, което го прави отличен избор за детско спално бельо.
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Предлагаме два вида плат:
        </Typography>

        <Typography variant="h6" component="h3" fontWeight={600} sx={{ mb: 1 }}>
          Ранфорс
        </Typography>
        <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
          Плътен и издръжлив памучен плат, подходящ за ежедневна употреба и често пране.
        </Typography>
        <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
          Можете да разгледате всички{' '}
          <Typography
            variant="body1"
            component={Link}
            to="/produkti/detsko-spalno-belio/detski-kalufki/2/8/2"
            sx={seoLinkStyle}>
            детски калъфки ранфорс
          </Typography>
          , както и да ги комбинирате с{' '}
          <Typography
            variant="body1"
            component={Link}
            to="/produkti/detsko-spalno-belio/detski-plikove/2/10/2"
            sx={seoLinkStyle}>
            детски пликове ранфорс
          </Typography>
          ,{' '}
          <Typography
            variant="body1"
            component={Link}
            to="/produkti/detsko-spalno-belio/detski-charshafi/2/7/2"
            sx={seoLinkStyle}>
            детски чаршафи ранфорс (без ластик)
          </Typography>
          ,{' '}
          <Typography
            variant="body1"
            component={Link}
            to="/produkti/detsko-spalno-belio/detski-charshafi-s-lastik/2/9/2"
            sx={seoLinkStyle}>
            детски чаршафи с ластик ранфорс
          </Typography>
        </Typography>

        <Typography variant="h6" component="h3" fontWeight={600} sx={{ mb: 1, mt: 2 }}>
          Памучен сатен
        </Typography>
        <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
          По-фин и гладък памучен плат с лек естествен блясък и по-мека текстура.
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Ако предпочитате по-гладка материя, можете да изберете{' '}
          <Typography
            variant="body1"
            component={Link}
            to="/produkti/detsko-spalno-belio/detski-kalufki/2/8/1"
            sx={seoLinkStyle}>
            детски калъфки памучен сатен
          </Typography>
          , както и{' '}
          <Typography
            variant="body1"
            component={Link}
            to="/produkti/detsko-spalno-belio/detski-plikove/2/10/1"
            sx={seoLinkStyle}>
            детски пликове памучен сатен
          </Typography>
          ,{' '}
          <Typography
            variant="body1"
            component={Link}
            to="/produkti/detsko-spalno-belio/detski-charshafi/2/7/1"
            sx={seoLinkStyle}>
            детски чаршафи памучен сатен (без ластик)
          </Typography>
          ,{' '}
          <Typography
            variant="body1"
            component={Link}
            to="/produkti/detsko-spalno-belio/detski-charshafi-s-lastik/2/9/1"
            sx={seoLinkStyle}>
            детски чаршафи с ластик памучен сатен
          </Typography>
        </Typography>
        <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary' }}>
          И двата вида плат са дишащи, безопасни и подходящи за чувствителната кожа на бебета и
          деца.
        </Typography>

        {/* H2: Предимства на нашите детски калъфки */}
        <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2, mt: 4 }}>
          Предимства на нашите детски калъфки
        </Typography>
        <Box component="ul" sx={{ mb: 2, pl: 4, color: 'text.secondary' }}>
          <li>&#10004; изработени от 100% памук</li>
          <li>&#10004; избор между ранфорс и памучен сатен</li>
          <li>&#10004; голямо разнообразие от размери</li>
          <li>&#10004; подходящи за бебешки и детски възглавници</li>
          <li>&#10004; платове със сертификат OEKO-TEX Standard 100</li>
          <li>&#10004; безопасни за чувствителната детска кожа</li>
          <li>&#10004; произведени в България</li>
        </Box>
        <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary' }}>
          Нашите калъфки за детски възглавници са практично решение за родители, които търсят
          качествено, безопасно и удобно детско спално бельо.
        </Typography>

        {/* H2: Калъфки за бебешки и детски възглавници по размер */}
        <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
          Калъфки за бебешки и детски възглавници по размер
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Калъфките се предлагат в различни размери, за да паснат точно на бебешките и детските
          възглавници.
        </Typography>
        <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
          При нас можете да откриете калъфки в популярни размери:
        </Typography>
        <Box component="ul" sx={{ mb: 2, pl: 4, color: 'text.secondary' }}>
          <li>калъфка за бебешка възглавница 30/40 (30х40) см</li>
          <li>калъфка за детска възглавница 40/60 (40х60) см</li>
          <li>калъфка за възглавница 35/53 (35х53) см</li>
          <li>калъфка за възглавница 40/50 (40х50) см</li>
          <li>калъфка за възглавница 50/70 (50х70) см</li>
          <li>калъфка за възглавница 70/70 (70х70) см</li>
        </Box>
        <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
          Калъфките могат лесно да се комбинират с{' '}
          <Typography
            variant="body1"
            component={Link}
            to="/kategorii/detsko-spalno-belio/detski-plikove/2/10"
            sx={seoLinkStyle}>
            детски пликове за завивки
          </Typography>
          ,{' '}
          <Typography
            variant="body1"
            component={Link}
            to="/kategorii/detsko-spalno-belio/detski-charshafi/2/7"
            sx={seoLinkStyle}>
            детски чаршафи
          </Typography>
          ,{' '}
          <Typography
            variant="body1"
            component={Link}
            to="/kategorii/detsko-spalno-belio/detski-charshafi-s-lastik/2/9"
            sx={seoLinkStyle}>
            детски чаршафи с ластик
          </Typography>
          , за да създадете удобен комплект детско спално бельо.
        </Typography>

        {/* H2: Срок за изработка */}
        <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2, mt: 4 }}>
          Срок за изработка
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Всички калъфки се изработват индивидуално след направена поръчка, според избрания размер.
        </Typography>
        <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary' }}>
          Срокът за изработка е между 3 и 10 работни дни, като в повечето случаи поръчките са готови
          в рамките на 4–7 работни дни.
        </Typography>
      </Collapse>
      <Button
        onClick={() => setExpanded(!expanded)}
        sx={{
          color: '#F57819',
          textTransform: 'none',
          fontWeight: 600,
          mb: 3,
          '&:hover': { backgroundColor: 'rgba(212, 175, 55, 0.08)' }
        }}>
        {expanded ? 'Скрий' : 'Прочетете повече'}
      </Button>

      {/* H2: ЧЗВ */}
      <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 3 }}>
        Често задавани въпроси за калъфки за детски възглавници
      </Typography>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Как да избера правилния размер калъфка за възглавница?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            Измерете ширината и дължината на възглавницата и изберете калъфка със същия размер.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Подходящи ли са калъфките за бебешки възглавници?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            Да. Предлагаме калъфки в по-малки размери, които са подходящи за бебешки възглавници,
            например 28/35 и 30/40.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Какъв плат да избера – ранфорс или памучен сатен?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            И двата вида плат са 100% памук и са подходящи за детско спално бельо. Ранфорсът е
            по-устойчив и практичен за ежедневна употреба, а памучният сатен е по-гладък и мек на
            допир.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Свиват ли се памучните калъфки след пране?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            Както всички изделия от 100% памук, калъфките могат да имат естествена свиваемост около
            4–5% след първите пранета.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Къде се изработват калъфките?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            Всички калъфки за детски възглавници се изработват в България, специално за всяка
            поръчка и според избрания размер.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            За колко време се изработва калъфка за възглавница?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            Срокът за изработка е между 3 и 10 работни дни, като в повечето случаи поръчките са
            готови за 4–7 работни дни.
          </Typography>
        </AccordionDetails>
      </Accordion>
    </Box>
  );
}
